module.exports = __webpack_public_path__ + "static/media/cam-01.a20cce8c.webp";